import { defineStore } from "pinia";

// Notifiche dell'utente: quante non lette (il numero della campanella) e le azioni che le cambiano. Gli elenchi (tendina, pagina) sono locali a chi li mostra e si
// ricaricano quando cambia `versione`, che sale a ogni lettura o archiviazione: così numero ed elenchi restano allineati senza passarsi i dati.
interface RispostaConteggio {
  non_lette?: number;
  error?: string;
}
interface RispostaAzione {
  success?: boolean;
  error?: string;
}

export const useNotificheStore = defineStore("notifiche", () => {
  const { authFetch } = useAuthFetch();
  const nonLette = ref(0);
  const versione = ref(0);

  /** Rilegge il numero delle non lette; un errore lascia il numero com'era (la campanella non deve mai dire una cosa sbagliata né rompere la pagina). */
  async function aggiorna(): Promise<void> {
    try {
      const risposta = await authFetch<RispostaConteggio>("/api/notifiche/conta_non_lette", { autoCancel: true });
      if (typeof risposta?.non_lette === "number" && Number.isFinite(risposta.non_lette) && risposta.non_lette >= 0) nonLette.value = Math.floor(risposta.non_lette);
    } catch {
      // interruzione voluta o rete assente: resta il numero di prima
    }
  }

  async function esegui(url: string, body: Record<string, unknown>): Promise<boolean> {
    const risposta = await authFetch<RispostaAzione>(url, { body });
    if (!risposta?.success) return false;
    versione.value += 1;
    await aggiorna();
    return true;
  }

  const segnaLette = (ids: readonly number[]) => (ids.length ? esegui("/api/notifiche/segna_lette", { ids }) : Promise.resolve(true));
  const segnaTutteLette = () => esegui("/api/notifiche/segna_lette", { tutte: true });
  const archivia = (ids: readonly number[], archiviare = true) => (ids.length ? esegui("/api/notifiche/archivia", { ids, archivia: archiviare }) : Promise.resolve(true));
  /** Il server ha creato una notifica per l'utente (tempo reale, task successivo): si rilegge tutto. */
  const nuoveNotifiche = async (): Promise<void> => {
    versione.value += 1;
    await aggiorna();
  };

  return { nonLette, versione, aggiorna, segnaLette, segnaTutteLette, archivia, nuoveNotifiche };
});
